export const imageAnime = {
  from: {
    opacity: 0,
  },
  to: {
    opacity: 1,
    transition: {
      delay: 0.3,
    },
  },
};
